import { DateFormat } from './../../../constants/date-format.constants';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'scf-vendor-agreement-text',
    template: `<div class="vendor-agreement-text">
        <p>
            To complete enrollment, please completely scroll through and read the following
            information.
        </p>
        <p>
            <b>
                THE SUPPLIER AGREEMENT IS INTENDED TO BE EXECUTED AND ACCEPTED ELECTRONICALLY. THE
                INDIVIDUAL (NATURAL PERSON) WHO ACCEPTS THE SUPPLIER AGREEMENT BY THE ELECTRONIC
                MEANS AFFORDED, REPRESENTS AND WARRANTS THAT HE OR SHE IS THE AUTHORIZED HOLDER OF
                THE USER ID AND PASSWORD ASSIGNED TO THE SUPPLIER REFERENCED HEREIN, AND IS AN
                OFFICER OF SUPPLIER WITH FULL POWER AND AUTHORITY TO EXECUTE AND ACCEPT THIS
                AGREEMENT ELECTRONICALLY ON SUPPLIER’S BEHALF.
            </b>
        </p>
        <p>
            This Supplier Agreement, dated {{ today | date: dateFormat.LongDate }}, is made by and
            between the Person to whom LSQ has allocated the user ID and password that provide
            access to the System, and is identified as Supplier and LSQ FUNDING GROUP, L.C., a
            Florida limited liability company (together with its respective successors and assigns,
            "LSQ").
        </p>

        <h2>BACKGROUND</h2>
        <p>
            Supplier is a provider of goods and/or services to Buyer which gives rise to Invoices
            owing by Buyer to Supplier. Buyer has entered into a Buyer Agreement with LSQ wherein
            LSQ has agreed to assume certain obligations of Buyer owing by it to Suppliers. To
            facilitate the payment of those Invoices and discharge Buyer’s Obligations thereunder,
            Supplier and Buyer utilize the Program.
        </p>
        <p>
            Supplier may from time to time desire to receive payment on one or more Invoices prior
            to the stated due date thereof, and LSQ is willing, in its sole discretion and on a
            case-by-case basis after review of such Invoices, to assume the payment obligations of
            Buyer with respect to one or more of such Invoices, and facilitate Supplier’s receipt of
            payment prior to the stated due date of such Invoices on the terms and conditions set
            forth below.
        </p>
        <p>
            NOW, THEREFORE, in consideration of the foregoing premises and other good and valuable
            consideration, the receipt and sufficiency of which is hereby acknowledged, the Parties
            agree as follows:
        </p>

        <h2>ARTICLE I: SYSTEM MECHANICS</h2>
        <p>
            1.1 <u>Submitting Supplier Offers.</u> Buyer, at its sole option, may from time to time
            submit to the System one or more Invoices owing to Supplier by Buyer which may be
            considered by Supplier and LSQ for early payment pursuant to the Program. Supplier may,
            at its sole option, submit an offer (a <u>"Supplier Offer"</u>) with respect to an
            Invoice to consent and agree to:
        </p>
        <p>
            (a) the novation to, and the assumption by, LSQ, of the Invoice Payment Obligation of
            Buyer with respect to such Invoice;
        </p>
        <p>
            (b) the release by Supplier of Buyer from all Invoice Payment Obligations with respect
            to such Invoice, in exchange for LSQ’s agreement to pay to Supplier an amount equal to
            the Payment Amount with respect to such Invoice by the LSQ Payment Deadline; and
        </p>
        <p>
            (c) the acceptance of the Payment Amount paid on or before the LSQ Payment Deadline as
            satisfaction in full of all Invoice Payment Obligations with respect to such Invoice.
        </p>
        <p>
            Each such Supplier Offer shall be made by selecting the FastTrack® option to request
            early payment on the System and shall remain open and eligible for acceptance until the
            earliest of LSQ’s issuance of an LSQ Acceptance of such Supplier Offer, or LSQ’s
            Rejection of such Supplier Offer.
        </p>
        <p>
            1.2 <u>Irrevocability of Supplier Offers.</u> Each Supplier Offer, once submitted, shall
            be irrevocable by Supplier until Accepted or Rejected by LSQ.
        </p>
        <p>1.3 <u>Offer Acceptance or Rejection</u>.</p>
        <p>
            (a) <u>Acceptance.</u> LSQ, at its sole option, may accept a Supplier Offer by
            depositing the Payment Amount corresponding to such Invoice in the Supplier Bank Account
            on or before the LSQ Payment Deadline (each, an "<u>LSQ Acceptance</u>" and such
            Supplier Offer having been "<u>Accepted</u>"). In the event Supplier receives payment
            from both LSQ and Buyer with respect to any Invoice, Supplier shall immediately remit
            the Buyer’s payment to LSQ.
        </p>
        <p>
            (b) <u>Rejection.</u> If LSQ (i) indicates at any time prior to the LSQ Payment Deadline
            that a Supplier Offer is not accepted, or (ii) has not deposited the Payment Amount with
            respect to an Invoice in the Supplier Bank Account by the LSQ Payment Deadline, the
            Supplier Offer shall be deemed rejected by LSQ (each, a "<u>Rejection</u>" and such
            Supplier Offer having been "<u>Rejected</u>"), in which case Supplier shall seek payment
            of the Invoice from Buyer. LSQ shall have no responsibility to Supplier with respect to
            any Invoice for which a Supplier Offer has been Rejected.
        </p>

        <p>1.4 <u>Effect of Acceptance of a Supplier Offer</u>.</p>
        <p>
            (a) Supplier hereby agrees that, simultaneously with each LSQ Acceptance in respect of a
            Supplier Offer, Supplier shall be deemed automatically, and without any further action
            on the part of Supplier, Buyer or any other Person, to have consented to the novation of
            the applicable Invoice Payment Obligation, consented to the assumption by LSQ of Buyer’s
            obligations under the applicable Invoice, released Buyer from any and all Invoice
            Payment Obligations with respect to such Invoice, acknowledged that Supplier’s sole
            recourse for payment of the applicable Invoice shall be against LSQ and not Buyer, and
            that receipt of the Payment Amount constitutes satisfaction in full of the applicable
            Invoice. Buyer shall be a third party beneficiary of the immediately preceding sentence.
        </p>
        <p>
            (b) Supplier (i) agrees to sign all such documents, and take all such further actions as
            LSQ may reasonably request to evidence each LSQ Acceptance and payment of the Payment
            Amount by LSQ to Supplier; and (ii) authorizes LSQ to notify Buyer that LSQ has Accepted
            a Supplier Offer and made payment to Supplier with respect to such Invoice.
        </p>
        <p>
            1.5 <u>Parties’ Discretion</u>. LSQ acknowledges that Supplier is not obligated to
            submit any Supplier Offer and the decision by Supplier to submit any Supplier Offer is
            in Supplier’s sole discretion. Supplier acknowledges that LSQ is not obligated to accept
            any Supplier Offer and the decision to accept any Supplier Offer is in LSQ’s sole
            discretion.
        </p>
        <p>
            1.6 <u>Claims</u>. Supplier acknowledges and agrees that any resolution of Claims
            between Buyer and Supplier are beyond the scope of this Agreement and are to be resolved
            directly by Buyer and Supplier.
        </p>
        <h2>ARTICLE II: REPRESENTATIONS, WARRANTIES AND COVENANTS</h2>
        <br />
        <p>
            2.1 <u>Mutual Representations and Warranties of the Parties</u>. Each of Supplier and
            LSQ represents and warrants as follows: (i) it is validly existing and in good standing
            and has the power to enter into and perform, and has all necessary authorizations for
            the entry into, performance and delivery of, this Agreement and the transactions
            contemplated by this Agreement; (ii) this Agreement constitutes its legal, valid and
            binding obligation, enforceable in accordance with the Agreement’s terms; and (iii) its
            execution, delivery and performance of this Agreement does not (A) contravene its
            organizational documents or any contract binding on or affecting it or any of its
            properties, (B) violate any applicable law, regulation or order, or (C) require any
            notice, filing or other action to or by any governmental body or other person or entity.
        </p>
        <p>
            2.2 <u>Supplier Representations and Warranties</u>. Supplier makes the following
            representations and warranties, on the date of each Supplier Offer and an LSQ
            Acceptance:
        </p>
        <p>
            (a) Each such Invoice (i) relates exclusively to a commercial trade transaction and
            represents consideration for the sale of goods and/or services (A) that have been
            rendered to Buyer in the ordinary course of business, (B) in relation to which all of
            Supplier’s obligations giving rise to payment have been performed by it in full, (C) is
            not subject to any dispute of any kind, whether or not such dispute is valid, and (D)
            that complies with applicable law; and (ii) is the exclusive property of Supplier and
            may be novated to LSQ.
        </p>
        <p>
            (b) Each Person that makes an entry on the System on behalf of Supplier in connection
            with any Transaction has been duly authorized by Supplier and each such entry is binding
            on Supplier, and the information so entered is accurate and complete.
        </p>
        <p>2.3 <u>Supplier Covenants</u>. Supplier hereby covenants and agrees as follows:</p>
        <p>
            (a) Supplier shall use the System solely to settle genuine and lawful commercial trade
            transactions, arising in the ordinary course of business, for the sale of goods and/or
            services by Supplier to Buyer.
        </p>
        <p>
            (b) Supplier shall comply with all relevant laws applicable to this Agreement and agrees
            to execute any documents LSQ may reasonably request to protect LSQ’s rights and benefits
            under this Agreement.
        </p>

        <p>
            (c) Supplier shall not, at any time after making a Supplier Offer and until such
            Supplier Offer is Accepted or Rejected, sell, assign, or transfer any right, title or
            interest in the applicable Invoice to any other Person or grant or agree to any
            assumption or novation in respect of such Invoice except in favor of LSQ.
        </p>

        <h2>ARTICLE III: MISCELLANEOUS</h2>
        <p>
            3.1 <u>Waivers; Severability</u>. No delay or failure of any Party hereto in exercising
            any right, privilege or option under this Agreement shall operate as a waiver of such or
            of any other right. If any provision of this Agreement is or becomes illegal or invalid
            under any applicable law, the validity of the remaining provisions shall not be affected
            thereby.
        </p>
        <p>3.2 <u>Limitation on Liability</u>.</p>
        <p>
            (a) LSQ shall be entitled to rely on any Message sent or purported to be sent by
            Supplier, irrespective of any error or fraud contained in the Message or the identity of
            the individual who sent the communication, and shall not be liable for any action taken
            or omitted in reliance on any Message believed by it in good faith to be genuine.
        </p>
        <p>
            (b) Except for liabilities to third parties relating to defense and indemnification
            obligations hereunder, neither Party shall be liable to the other Party or responsible
            for any loss of business or profits, revenue or goodwill, or any indirect or
            consequential, special, exemplary or punitive losses or damages, whether arising from
            negligence, breach of contract or otherwise.
        </p>
        <p>
            (c) LSQ shall not be liable for any Losses arising out of or relating to any of its
            actions or omissions to act hereunder, except to the extent that any such Losses are
            directly caused by LSQ’s gross negligence or willful misconduct as determined by a
            final, non-appealable judgment of a court of competent jurisdiction.
        </p>
        <p>
            3.3 <u>No Implied Duties or Warranties</u>. Notwithstanding any other provision in this
            Agreement, LSQ shall have no duties or obligations hereunder to any Person or entity
            other than Supplier and, without limiting the foregoing, does not assume any obligation
            or relationship of agency or trust hereunder for, or with, Supplier, Buyer, or any other
            Persons.
        </p>
        <p>3.4 <u>Confidentiality</u>.</p>
        <p>
            (a) Each Party agrees to maintain the confidentiality of any Confidential Information
            (as defined below) of the other Party to which it has access under the System or
            otherwise under this Agreement, and to use such Confidential Information only for the
            purposes of exercising its rights and performing its obligations under this Agreement
            and the Buyer Agreement, and not for its own benefit. "<u>Confidential Information</u>"
            means information of a Party that the other Party knows or reasonably should know to be
            confidential to such first Party.
        </p>
        <p>
            (b) Notwithstanding the foregoing, either Party may disclose Confidential Information
            obtained from the other Party: (i) to any authority of competent jurisdiction pursuant
            to legal process or pursuant to any other legal or regulatory obligation or request,
            including disclosure to courts or other governmental bodies; (ii) to its subsidiaries
            and affiliates; and (iii) to its professional advisors, auditors and service providers.
            In addition, LSQ may disclose Confidential Information obtained from Supplier to (i) any
            provider of financing to LSQ (and any such provider’s professional advisors, auditors
            and services providers) and (ii) subject to Section 3.6, to any Person to (or through)
            whom LSQ sells, assigns or transfers (or may potentially assign or transfer) all or any
            of its rights and obligations under this Agreement.
        </p>
        <p>
            3.5 <u>Indemnity</u>. Supplier shall defend, indemnify and hold harmless LSQ and its
            affiliates, employees, directors, officers, and agents from and against all Losses,
            including, without limitation, Losses arising out of or in any way relating to (i) any
            breach of Supplier’s obligations, representations or warranties under this Agreement,
            (ii) LSQ’s reliance on any communication sent or purported to be sent by Supplier, or
            (iii) any Claim with respect to a commercial transaction giving rise to any Invoice.
        </p>
        <p>
            3.6 <u>Assignment</u>. This Agreement shall bind and inure to the benefit of the
            respective successors, permitted assigns and transferees of each of the Parties;
            provided, however, that Supplier may not assign or transfer any of its rights or
            obligations hereunder without LSQ’s prior written consent, given in its sole discretion.
        </p>
        <p>
            3.7 <u>Termination</u>. Either Party may terminate this Agreement for any reason upon 30
            Business Days’ prior written or electronic notice to the other Party. Upon the effective
            date of termination, Supplier shall no longer submit Supplier Offers and LSQ will no
            longer issue LSQ Acceptances, but a termination shall not limit or impair each Party’s
            obligations with respect to Accepted Supplier Offers as of the effective date of
            termination. LSQ may terminate this Agreement at any time upon Supplier’s breach of any
            representation, warranty, covenant or obligation under this Agreement.
        </p>
        <p>
            3.8 <u>Survival</u>. All representations and warranties, and all confidentiality and
            indemnity obligations and all limitation of liability provisions contained in this
            Agreement shall survive and remain in full force and effect notwithstanding termination
            or expiration of this Agreement.
        </p>
        <p>
            3.9 <u>Notices</u>. Except as otherwise expressly contemplated herein, all notices
            pursuant to this Agreement shall be delivered, emailed or mailed (a) if to LSQ, to 315
            E. Robinson St., Suite 200, Orlando, FL 32801, fasttrack-support@lsq.com and (b) if to
            Supplier, to the address set forth for Supplier on the System.
        </p>
        <p>
            3.10 <u>Entire Agreement; Third Party Beneficiaries; Amendments</u>. This Agreement (i)
            embodies the entire agreement between Supplier and LSQ relating to the subject matter
            hereof, and supersedes all prior agreements relating to this subject matter, (ii) shall
            not be construed to confer any right, benefit, remedy or claim upon any Person other
            than Supplier, LSQ, and (solely with respect to Section 1.4(a)) Buyer, and their
            respective successors and permitted assigns, and (iii) may only be amended by the
            Parties in a writing signed by the Parties, provided that no amendment to Section 1.4(a)
            shall be permitted without Buyer’s written consent.
        </p>
        <p>
            3.11 <u>Ownership</u>. LSQ retains all right, title, and interest in and to the System,
            including all intellectual property associated therewith, and all derivative works
            thereof. LSQ is making the System available to Supplier and its authorized End Users
            pursuant to the terms of an End User Licensing Agreement ("EULA"). Supplier is
            responsible for its End Users’ compliance with the EULA.
        </p>
        <p>
            3.12 <u>Data</u>. LSQ shall have an unrestricted right to use any data provided by
            anyone in the Program for any reason, including, but not limited to, operational or
            administrative purposes to facilitate or enhance the Program.
        </p>
        <p>
            3.13 <u>Electronic Execution and Communications</u>. The Parties acknowledge and agree
            that the use of electronic communications to submit Supplier Offers, accept or reject
            Supplier Offers, and amend the Agreement shall be binding on the Parties to the same
            extent as if conducted in writing on paper. The Parties agree that such actions will be
            valid and binding obligations of the parties, as if such actions had been taken in
            writing on paper.
        </p>
        <p>
            3.14 <u>Governing Law and Jurisdiction</u>. This Agreement is governed by the internal
            laws of the State of Delaware. The Parties agree that any suit, action, or proceeding
            arising out of the subject matter or the interpretation, performance, or breach of this
            Agreement, shall be instituted in any state or federal court of Orange County, Florida
            (the "<u>Acceptable Forum</u>"). Each Party agrees that the Acceptable Forum is
            convenient to it, and each Party irrevocably submits to the jurisdiction of the
            Acceptable Forum, irrevocably agrees to be bound by any judgment rendered by a court in
            the Acceptable Forum, and waives any and all objections to jurisdiction or venue that it
            may have under the laws of the Acceptable Forum or otherwise in those courts in any such
            suit, action, or proceeding. A final judgment in any proceeding of any such court shall
            be conclusive and may be enforced in other jurisdictions by suit on the judgment or any
            other manner provided by applicable law.
        </p>
        <p>
            3.15 <u>WAIVER OF JURY TRIAL</u>. THE PARTIES WAIVE ANY RIGHTS THEY MAY HAVE TO A JURY
            TRIAL OF ANY CLAIM OR CAUSE OF ACTION BASED ON OR ARISING FROM THIS AGREEMENT OR ANY
            CONDUCT, ACTS OR OMISSIONS OF ANY PARTY, WHETHER SOUNDING IN CONTRACT, TORT OR
            OTHERWISE.
        </p>
        <p>
            3.16 <u>Declaration</u>. Supplier confirms that it (i) has received independent legal,
            tax and accounting advice in relation to the transactions contemplated by this Agreement
            and (ii) has not relied on any representation by LSQ in this regard.
        </p>

        <h2>ARTICLE IV: DEFINITIONS</h2>
        <p>
            For the purposes of this Agreement the following terms shall have the following
            meanings:
        </p>
        <p>
            "<u>Agreement</u>" means this Supplier Agreement, including all Schedules attached
            hereto, in each case as amended from time to time.
        </p>
        <p>
            "<u>Approve</u>" or "<u>Approval</u>" means Buyer’s designation on the System that an
            Invoice is eligible for payment through the System in the Approved Amount.
        </p>
        <p>
            "<u>Approved Amount</u>" means the amount with respect to any Invoice representing an
            Invoice that Buyer has Approved.
        </p>
        <p>
            "<u>Business Day</u>" means any day (excluding Saturdays and Sundays) on which
            commercial banks are open for business in the Delaware.
        </p>
        <p>
            "<u>Buyer</u>" means a client or buyer of Supplier that has entered into a Buyer
            Agreement with LSQ and settles the payment of Invoices using the System, in each case
            together with its successors and permitted assigns. For purposes of this Agreement, all
            references to "Buyer" shall mean the same, individual Buyer for such transaction even
            though Supplier may settle payment of Invoices with more than one Buyer using the
            System.
        </p>
        <p>
            "<u>Buyer Agreement</u>" means the Buyer Agreement between Buyer and LSQ, as amended
            from time to time.
        </p>
        <p>
            "<u>Claim</u>" means any abatement, charge, claim, claw-back, counterclaim, defense,
            deferral, lien, netting, offset, reduction, recovery, set off right, withholding or
            other right, dispute or claim.
        </p>
        <p>
            "<u>End Users</u>" means employees, agents or contractors of Supplier who have been
            provided Logins by Supplier to access the System and who have agreed to the EULA.
        </p>
        <p>
            "<u>Invoice</u>" means the invoice or other payment instructions generated by Supplier
            and uploaded to the System arising out of Supplier’s sale of goods and/or services
            provided to Buyer.
        </p>
        <p>"<u>Invoiced Amount</u>" means the face amount of any Invoice.</p>
        <p>
            "<u>Invoice Payment Obligation</u>" means the obligation of Buyer to pay for goods
            and/or services provided to Buyer relating to a particular Invoice, the amount and
            currency of which has been uploaded into the System, whether or not earned by
            performance.
        </p>
        <p>
            "<u>Logins</u>" means usernames and passwords for End Users to access the System.
        </p>
        <p>
            "<u>Losses</u>" means any claims, liabilities, losses, damages, costs or expenses,
            including reasonable attorneys’ fees and disbursements, other dispute resolution
            expenses and costs of collection.
        </p>
        <p>
            "<u>LSQ Acceptance</u>" and "<u>Accepted</u>" have the meanings given them in Section
            1.3(a).
        </p>
        <p>
            "<u>LSQ Payment Deadline</u>" means, with respect to any Transaction, any date that is
            within 3 Business Days after Supplier submits a Supplier Offer pursuant to Section 1.1.
        </p>
        <p>
            "<u>Message</u>" means any message, information or instruction that is transmitted
            through the System, including any communication relating to a Transaction.
        </p>
        <p>
            "<u>Party</u>" or "<u>Parties</u>" means each or both of Supplier or LSQ, as the context
            requires.
        </p>
        <p>"<u>Payment Amount</u>" is the Invoiced Amount less the Transaction Fee.</p>
        <p>
            "<u>Person</u>" means any individual, sole proprietorship, partnership, corporation,
            trust, association, limited liability company, limited liability partnership,
            institution, public benefit corporation, joint venture, governmental body or any other
            entity.
        </p>
        <p>
            "<u>Program</u>" means the program evidenced by this Agreement and any Buyer Agreement
            with respect to the System, which facilitates the payment by LSQ of Invoices owing to
            Supplier by Buyer prior to the applicable due dates thereof.
        </p>
        <p>
            "<u>Rejected</u>" and "<u>Rejection</u>" have the meanings given them in Section 1.3(b).
        </p>
        <p>
            "<u>System</u>" means LSQ FastTrack®, including related services, equipment and
            software, to facilitate the processing of Invoices, and payments made with respect
            thereto.
        </p>
        <p>"<u>Supplier Bank Account</u>" means Supplier’s bank account designated by Supplier.</p>
        <p>"<u>Supplier Offer</u>" has the meaning given it in Section 1.1.</p>
        <p>
            "<u>Transaction</u>" means a trade/supplier finance transaction permitted by this
            Agreement, transacted using the System.
        </p>
        <p>
            "<u>Transaction Fee</u>" means, with respect to each Invoice, the amount set forth on
            the System with respect to such Invoice immediately prior to Supplier making a Supplier
            Offer with respect thereto.
        </p>
        <p>
            <b>
                You have read and understand the terms and conditions of this Supplier Agreement,
                for and on behalf of {{ sellerName }} ("Supplier").
            </b>
        </p>

        <p>
            <b>
                By clicking "I accept", you confirm you have read and agreed to the
                <u>LSQ Terms of Service</u>, and you shall have executed and accepted the Supplier
                Agreement on behalf of Supplier. By executing and accepting this Supplier Agreement
                on behalf of Supplier as set forth above, you represent and warrant that you are an
                officer or other representative of Supplier with full power and authority to execute
                and accept this Agreement electronically on Supplier’s behalf.
            </b>
        </p>
    </div>`,
    styleUrls: ['./scf-vendor-agreement-text.component.scss']
})
export class ScfVendorAgreementTextComponent {
    public readonly today = new Date();
    public readonly dateFormat = DateFormat;

    @Input() public sellerName: string;
}
